const skillsData = ["problem solving", "communication", "teamwork", "unit testing", "proactiveness","persistence","agile","scrum"];

export default skillsData;